import { render, staticRenderFns } from "./EncourageHateNotif.vue?vue&type=template&id=7238dd1c&"
import script from "./EncourageHateNotif.vue?vue&type=script&lang=js&"
export * from "./EncourageHateNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports